export interface Market {
    id: number;
    name: string;
    description: string;
}
